import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase/config';
import { useTranslation } from 'react-i18next';
import './Auth.css';

interface LocationState {
  from: {
    pathname: string;
  };
}

const SignIn = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const history = useHistory();
  const location = useLocation<LocationState>();
  const { t } = useTranslation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // Si el usuario ya está autenticado, redirigir
        const destination = location.state?.from?.pathname || '/pos';
        history.replace(destination);
      }
    });

    // Limpiar el listener cuando el componente se desmonte
    return () => unsubscribe();
  }, [history, location]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      console.log(await userCredential.user.getIdToken())
      // Redirigir al usuario a la página que intentaba acceder o al terminal por defecto
      const destination = location.state?.from?.pathname || '/pos';
      history.replace(destination);
    } catch (err) {
      console.error('Error al iniciar sesión:', err);
      setError(t('auth.error'));
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>{t('auth.signIn')}</h2>
        {error && <div className="auth-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">{t('auth.email')}</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">{t('auth.password')}</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="submit-button">
            {t('auth.signIn')}
          </button>
        </form>
        <p className="auth-link">
          {t('auth.noAccount')} <Link to="/signup">{t('auth.signUp')}</Link>
        </p>
      </div>
    </div>
  );
};

export default SignIn;
